import { render, staticRenderFns } from "./PlacePrizesWidget.vue?vue&type=template&id=faf0ccaa&"
import script from "./PlacePrizesWidget.vue?vue&type=script&lang=js&"
export * from "./PlacePrizesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports